import { __assign } from './node_modules/tslib/tslib.es6.js';
import * as React from 'react';

var SvgChevronUp = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, className: "lucide lucide-chevron-up", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "m18 15-6-6-6 6" }))); };

export { SvgChevronUp as default };
//# sourceMappingURL=chevron-up.js.map
